import axios from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ISubmitUrlsPayload,
  ICreateElementPayload,
  IFetchElementsPayload,
  IDeleteElementPayload,
} from './types'

const apiHeaders = {
  headers: {
    'Content-Type': 'application/json',
  }
}

export function createElement({ discardAfterCreate: _discardAfterCreate, ...payload }: ICreateElementPayload) {
  return axios.post(`/api/v1/elements/create_with_project`, convertToSnakeCase(payload), apiHeaders)
}

export function submitUrls(payload: ISubmitUrlsPayload) {
  return axios.post(`/api/v1/elements/youtube_dl_with_project`, convertToSnakeCase(payload), apiHeaders)
}

export function fetchElements(payload: IFetchElementsPayload) {
  return axios.get('/api/v1/elements', { params: convertToSnakeCase(payload) })
}

export function deleteElement(payload: IDeleteElementPayload) {
  return axios.delete(`/api/v1/elements/${payload.elementId}`, apiHeaders)
}
